import * as Actions from "../Actions/SuggestionFieldActions";

const initialState = {
    data: null,
    error: null,
};

const SuggestionFieldReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DATA:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.SUGGESTION_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default SuggestionFieldReducer;
